import Vue from "vue";
import _ from "lodash";
import Router from "vue-router";
import login from "../views/login.vue";
import loginAdmin from "../views/loginAdmin.vue";
import main from "../views/main.vue";
import notfound from "../views/common/notfound.vue";
import supplySystem from "./supplySystem";
import platformManagement from "./platformManagement";
import stadiumSystem from "./stadiumSystem";
import convalescenceSystem from "./convalescenceSystem";
import stadiumSuperviseSystem from "./stadiumSuperviseSystem";
import carWashSuperviseSystem from "./carWashSuperviseSystem";
import receptionSystem from "./receptionSystem";
import receptionSupervise from "./receptionSupervise";
import carInsuranceSystem from "./carInsuranceSystem";
import selfStudySystem from "./selfStudySystem";
import systemManagement from "./systemManagement";

Vue.use(Router);

const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};

// 合并导入的所有子路由
const childrenRouter = _.union(
  supplySystem,
  platformManagement,
  stadiumSystem,
  convalescenceSystem,
  stadiumSuperviseSystem,
  carWashSuperviseSystem,
  receptionSystem,
  receptionSupervise,
  carInsuranceSystem,
  selfStudySystem,
  systemManagement
);

export default [
  {
    path: "/login",
    name: "login",
    meta: { title: "服务+管理系统登录" },
    component: login
  },
  {
    path: "/login_admin",
    name: "loginAdmin",
    meta: { title: "服务+管理系统登录" },
    component: loginAdmin
  },
  {
    path: "/",
    name: "app",
    component: main,
    redirect: "/login",
    children: childrenRouter
  },
  {
    path: "*",
    name: "404",
    meta: { title: "404" },
    component: notfound
  }
];
